import { c as _c } from "react/compiler-runtime";
import { cn } from '@newfront-insurance/core-ui/v2';
import type { ReactNode } from 'react';
import { useChatInputContext } from './chat-input-context';
import { useDragHandlersRef } from './chat-input-context';
interface ChatInputProps {
  children: ReactNode;
  className?: string;
}

/**
 * Root wrapper component for chat input.
 * Provides the form container and drag/drop handlers.
 * Handlers come from MessagePayloadProvider (populated by ChatAttachments if rendered).
 *
 * @example
 * ```tsx
 * <ChatInput>
 *   <ChatInputTextarea />
 *   <ChatInputToolbar>
 *     <ChatAttachments />
 *     <SendButton />
 *   </ChatInputToolbar>
 * </ChatInput>
 * ```
 */
export function ChatInput(t0) {
  const $ = _c(27);
  const {
    children,
    className
  } = t0;
  const context = useChatInputContext();
  const {
    handleSubmit,
    isPublicMode
  } = context;
  const handlersRef = useDragHandlersRef();
  const handlers = handlersRef.current;
  const isDragging = handlers.isDragging ?? false;
  let t1;
  if ($[0] !== handlers.handleDragOver) {
    t1 = handlers.handleDragOver ?? _temp;
    $[0] = handlers.handleDragOver;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleDragOver = t1;
  let t2;
  if ($[2] !== handlers.handleDragLeave) {
    t2 = handlers.handleDragLeave ?? _temp2;
    $[2] = handlers.handleDragLeave;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleDragLeave = t2;
  let t3;
  if ($[4] !== handlers.handleDrop) {
    t3 = handlers.handleDrop ?? _temp3;
    $[4] = handlers.handleDrop;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleDrop = t3;
  let t4;
  if ($[6] !== className) {
    t4 = cn("flex-shrink-0 px-2", className);
    $[6] = className;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== handleSubmit) {
    t5 = e => {
      e.preventDefault();
      handleSubmit(e);
    };
    $[8] = handleSubmit;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== isDragging || $[11] !== isPublicMode) {
    t6 = cn("group bg-lime-blue-gradient relative w-full rounded-lg p-[1px]", {
      "bg-transparent": isDragging,
      "bg-pink-yellow-gradient": isPublicMode
    });
    $[10] = isDragging;
    $[11] = isPublicMode;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== children) {
    t7 = <div className="flex w-full flex-col gap-0 overflow-hidden rounded-lg bg-white">{children}</div>;
    $[13] = children;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== handleDragLeave || $[16] !== handleDragOver || $[17] !== handleDrop || $[18] !== t6 || $[19] !== t7) {
    t8 = <div className={t6} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop}>{t7}</div>;
    $[15] = handleDragLeave;
    $[16] = handleDragOver;
    $[17] = handleDrop;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t5 || $[22] !== t8) {
    t9 = <form className="mx-auto flex w-full max-w-3xl gap-2" onSubmit={t5}>{t8}</form>;
    $[21] = t5;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t4 || $[25] !== t9) {
    t10 = <div className={t4}>{t9}</div>;
    $[24] = t4;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}
function _temp3() {}
function _temp2() {}
function _temp() {}